import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useAllocateSettings() {
  const {
    tours: {
      AccountingSettings: { Allocate },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: Allocate.Title,
      steps: [
        {
          content: Allocate.Step1.Text,
          placement: 'auto',
          target: '#allocateCategories',
          title: Allocate.Step1.Title,
          disableBeacon: true,
          link: Allocate.Step1.DetailsLink,
        },
        {
          content: Allocate.Step2.Text,
          placement: 'bottom',
          target: '#categoryList',
          title: Allocate.Step2.Title,
          disableBeacon: true,
          link: Allocate.Step2.DetailsLink,
          styles: {
            spotlight: {
              maxWidth: '200px',
            },
          },
        },
        {
          content: Allocate.Step3.Text,
          placement: 'auto',
          target: '#crudExtended',
          title: Allocate.Step3.Title,
          disableBeacon: true,
          link: Allocate.Step3.DetailsLink,
        },
      ],
    }),
    [Allocate],
  );

  return [pageTour];
}
